import { Inject, ChangeDetectionStrategy, OnDestroy, Component } from '@angular/core';
import { TimeoutService } from '@df/ng/timeout.service';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { NNotificationModal } from './notification.interfaces';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NotificationInitiatorService } from './notification-initiator.service';

@DfModal({
    id: NNotificationModal.id,
    position: 'right',
    config: sizeId => ({
        closeOnNavigation: false,
        transformOptions: 'translate3d(100%, 0px, 0px)',
        modalClass: 'p-a-0',
        position: {
            top: '10em',
            right: '5vw'
        },
        transitionOptions: '500ms ease-in-out',
        width: '20em'
    }),
    reopenPolicy: NDfModal.ReopenPolicy.wait,
    sizeRestriction: sizeId => ['S', 'M', 'L', 'X'],
    initiators: [NotificationInitiatorService]
})
@Component({
    templateUrl: './notification.modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationModalComponent implements OnDestroy {
    /**
     * Close timeout id
     */
    private timeoutId: number | undefined;

    /**
     * Close notification
     */
    constructor(
        private modalRef: ModalRef<NotificationModalComponent>,
        @Inject(MODAL_DATA) readonly data: NNotificationModal.IModalData,
        timeoutService: TimeoutService
    ) {
        timeoutService.setTimeout(() => {
            this.close();
        }, 5000);
    }

    /**
     * Close notification
     */
    close() {
        this.modalRef.close();
    }

    /**
     * Cleanup
     */
    ngOnDestroy() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }
}
